import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { StyledBackground } from '../Common/Styled/CommonStyled';
import Navbar from './Navbar';

export const BaseLayout = () => {
  return (
    <StyledBackground>
      <Navbar />
      <Container maxWidth={false} sx={{ paddingBottom: '50px' }}>
        <Box display="flex" justifyContent={'center'}>
          <Outlet />
        </Box>
      </Container>
    </StyledBackground>
  );
};
